import { render, staticRenderFns } from "./complaint-actions-tab.vue?vue&type=template&id=07d116e2&scoped=true"
import script from "./complaint-actions-tab.vue?vue&type=script&lang=js"
export * from "./complaint-actions-tab.vue?vue&type=script&lang=js"
import style0 from "./complaint-actions-tab.vue?vue&type=style&index=0&id=07d116e2&prod&lang=scss"
import style1 from "./complaint-actions-tab.vue?vue&type=style&index=1&id=07d116e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d116e2",
  null
  
)

export default component.exports